export default [
  {
    path: "/fkjz"
    // component: () => import("@views/home/index.vue")
  },
  {
    path: "/fkjz/fkjz_index",
    name: "fkjzindex",
    meta: {
      title: "梵客家装",
      keepAlive: true,
      backgroundColor: "#5d00d6",
      // auth: false
    },
    component: () => import("@views/fkjz/fkjz_index.vue")
  },
  {
    path: "/fkjz/fkjz_wqy",
    name: "fkjzwqy",
    meta: {
      title: "梵客家装",
      keepAlive: false,
      backgroundColor: "#5d00d6",
      // auth: true
    },
    component: () => import("@views/fkjz/fkjz_wqy.vue")
  },
  {
    path: "/fkjz/fkjz_yqy",
    name: "fkjzyqy",
    meta: {
      title: "梵客家装",
      keepAlive: false,
      backgroundColor: "#5d00d6",
      // auth: true
    },
    component: () => import("@views/fkjz/fkjz_yqy.vue")
  },
  {
    path: "/fkjz/fkjz_bm",
    name: "fkjzbm",
    meta: {
      title: "梵客家装报名",
      keepAlive: false,
      backgroundColor: "#5d00d6",
      // auth: true
    },
    component: () => import("@views/fkjz/fkjz_bm.vue")
  },
];
